(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (function () {
  var prose = document.querySelector('[data-llb-prose]');
  var slot  = document.querySelector('[data-llb-toc-slot]');
  if (!prose || !slot) return;

  var toc = prose.querySelector('.llb-edt-toc-src');
  if (toc) {
    toc.classList.add('llb-edt-toc');
    toc.classList.remove('llb-edt-toc-src');
    slot.appendChild(toc);
  }

  var links = toc ? Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]')) : [];
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {}, targets = [];
  links.forEach(function (a) {
    var el = document.getElementById(decodeURIComponent(a.hash.slice(1)));
    if (el) { map[el.id] = a.parentElement || a; targets.push(el); }
  });
  if (!targets.length) return;
  var current = null;
  function setActive(el) {
    if (current === el) return;
    for (var id in map) map[id].classList.remove('is-active');
    if (el && map[el.id]) map[el.id].classList.add('is-active');
    current = el;
  }
  setActive(targets[0]);
  var seen = new Map();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { seen.set(e.target, e.intersectionRatio > 0); });
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (seen.get(t) && t.getBoundingClientRect().top < window.innerHeight * 0.5) {
        var next = t;
        for (var j = i + 1; j < targets.length; j++) {
          if (seen.get(targets[j]) && targets[j].getBoundingClientRect().top < window.innerHeight * 0.5) next = targets[j];
        }
        setActive(next);
        return;
      }
    }
  }, { rootMargin: '-140px 0px -55% 0px', threshold: [0, 0.01, 0.5] });
  targets.forEach(function (t) { io.observe(t); });
})();

(function () {
  var rail = document.querySelector('.llb-edt-side');
  var toc  = rail && rail.querySelector('.llb-edt-toc');
  var fab  = document.querySelector('[data-llb-tocfab]');
  if (!rail || !toc || !fab) return;
  var pop = document.createElement('div');
  pop.className = 'llb-edt-tocpop';
  pop.hidden = true;
  pop.appendChild(toc.cloneNode(true));
  document.body.appendChild(pop);
  document.body.appendChild(fab);
  function close() { pop.hidden = true; fab.setAttribute('aria-expanded', 'false'); }
  fab.addEventListener('click', function (e) {
    e.stopPropagation();
    var open = pop.hidden;
    pop.hidden = !open;
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('click', function (e) { if (!pop.hidden && !pop.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  pop.addEventListener('click', function (e) { if (e.target.tagName === 'A') close(); });
  new IntersectionObserver(function (entries) {
    var visible = entries[0].isIntersecting;
    fab.hidden = visible;
    if (visible) close();
  }, { threshold: 0 }).observe(rail);
})();

(function () {
  var btn = document.querySelector('[data-llb-totop]');
  if (!btn) return;
  if (btn.parentNode !== document.body) document.body.appendChild(btn);
  function update() { btn.setAttribute('data-near-top', window.scrollY < 200 ? '1' : '0'); }
  btn.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({top:0,behavior:'smooth'}); });
  update();
  window.addEventListener('scroll', update, { passive: true });
})();

(function(){
  document.querySelectorAll('.llb-edt-related').forEach(function(sec){
    var track = sec.querySelector('[data-llb-rel-track]');
    var nav   = sec.querySelector('.llb-edt-related-nav');
    if (!track || !nav) return;
    var prev = nav.querySelector('[data-llb-rel="prev"]');
    var next = nav.querySelector('[data-llb-rel="next"]');
    var step = function(){
      var cards = track.querySelectorAll('li');
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      if (cards.length === 1) return cards[0].getBoundingClientRect().width;
      return track.clientWidth;
    };
    var sync = function(){
      var over = track.scrollWidth - track.clientWidth > 4;
      nav.hidden = !over;
      if (!over) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    var go = function(dir){
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', function(){ go(-1); });
    next.addEventListener('click', function(){ go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
